// Dependencies
import axios from 'axios';
import i18n from 'i18next';

// Interceptors
import responseInterceptor from '@nephro/core/axios/interceptors/responseInterceptor';

export class ExternalAxiosInstance {
  constructor(axiosConfig = {}) {
    this.http = axios.create(axiosConfig);
  }

  instance() {
    this.http.interceptors.response.use(responseInterceptor());
    return this.http;
  }
}

export const externalAxiosInstance = new ExternalAxiosInstance({
  headers: {
    'content-type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    Language: i18n.language,
    Country: 'COLOMBIA'
  }
}).instance();
